import { asyncLog } from 'shared/logger/asyncLog';
import { sharedLog } from 'shared/logger/sharedLog';
import {
  AdditionalSwLogInfo,
  LogEventGrouping,
  LogLevel,
  SwLogger,
} from 'shared/types/logger';
import { getCurrentUserIdentity } from './currentUserIdentity';
import { swSentryLog } from './initSentryInSw';
import { swSumoLogicLogger } from './swSumoLogicLogger';
import { frontendVersionWithBuildNumber } from 'shared/version';

function makeSwLogger(): SwLogger {
  const swLog = (
    msg: string,
    level: LogLevel,
    errorObject: unknown,
    additionalInfo: AdditionalSwLogInfo | null,
    grouping?: LogEventGrouping
  ): void => {
    // to be able to match a log with an async log we create logId by 'Date.now()'
    // this is not ideal, but it should be good enough for now.
    const logId = `${Date.now()}`;
    const { id: user_id, email: user_email } = getCurrentUserIdentity();
    sharedLog({
      user_id,
      user_email,
      logId,
      msg,
      level,
      full_error_object: errorObject,
      additionalInfo: {
        client_version: frontendVersionWithBuildNumber,
        ...additionalInfo,
      },
      grouping,
      loggers: [swSumoLogicLogger, { log: swSentryLog }],
    });

    // Storage details help with errors only; for the rest they doubled the logs.
    if (level === LogLevel.ERROR) {
      asyncLog(swSumoLogicLogger, logId, user_id, user_email).catch((e) =>
        // eslint-disable-next-line no-console
        console.log('Could not async log', e)
      );
    }
  };

  return swLog;
}

export const swLog = makeSwLogger();
